import TournamentDetails from "../views/TournamentDetails";
import RecentBestAll from "@/views/RecentBestAll";
import TournamentBundle from "@/views/TournamentBundle";
import TournamentPlay from "@/views/TournamentPlay";

export default [
    {
        path: "/tournament-details",
        name: "TournamentDetails",
        component: TournamentDetails,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/tournament-play/:id",
        name: "TournamentPlay",
        component: TournamentPlay,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/ranking-best-all",
        name: "RecentBestAll",
        component: RecentBestAll,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/tournament-bundle",
        name: "TournamentBundle",
        component: TournamentBundle,
        meta: {
            requiresAuth: true
        }
    },
];
